import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { ecoListColumns } from "@patronix/domain/list";
import { ecoListQuery } from "@/features/eco/api";
import { EcoListPage } from "@/features/eco/EcoListPage";
import { validateEcoSearch, type EcoSearch } from "@/features/eco/search";
import { activeCompanyOf } from "@/lib/activeCompany";
import { viewQuery } from "@/lib/listView";
import { sessionContextQuery } from "@/lib/session";

export const Route = createFileRoute("/_app/engineering/changes")({
  validateSearch: validateEcoSearch,
  loaderDeps: ({ search }) => ({ status: search.status, q: search.q, f: search.f, s: search.s }),
  loader: async ({ context, deps }) => {
    const ctx = await context.queryClient.ensureQueryData(sessionContextQuery);
    const companyId = activeCompanyOf(ctx)?.id;
    if (companyId) {
      await context.queryClient.ensureInfiniteQueryData(
        ecoListQuery(companyId, { status: deps.status, q: deps.q, ...viewQuery(ecoListColumns, deps) }),
      );
    }
  },
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (patch: Partial<EcoSearch>) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true }),
    [navigate],
  );
  return <EcoListPage search={search} setSearch={setSearch} />;
}
